import { AbstractModel } from '.';

class model extends AbstractModel {
    endpoint = 'activity-date';

    isLastActive(isActive, activityDates) {
        if (isActive) {
            let activeDates = 0;
            for (const activityDate of activityDates) {
                if (activityDate.isActive) {
                    activeDates++;
                    if (activeDates > 1) {
                        break;
                    }
                }
            }
            if (activeDates === 1) {
                return true;
            }
        }
        return false;
    }
}

export const ActivityDateModel = new model();
